import { config } from '../../config';

export interface StudioState {
  deleted:    string[];
  archived:   string[];
  /** Prototypes archivés dans leur code (meta.status) puis désarchivés depuis le catalogue. */
  unarchived?: string[];
  categories: Record<string, string>;
  titles:     Record<string, string>;
  descriptions?: Record<string, string>;
  /** Surcharges de statut faites dans le catalogue (absent des anciens états). */
  statuses?:  Record<string, string>;
}

export const EMPTY_STATE: StudioState = {
  deleted: [],
  archived: [],
  unarchived: [],
  categories: {},
  titles: {},
  descriptions: {},
  statuses: {},
};

async function getToken(): Promise<string> {
  const { oktaAuth } = await import('../../auth/OktaProvider');
  if (!oktaAuth) throw new Error('Okta not configured');
  const token = await oktaAuth.getOrRenewAccessToken();
  if (!token) throw new Error('No Okta access token');
  return token;
}

function stateUrl(): string {
  return `${config.bffUrl}/prototyper/state`;
}

export async function fetchState(): Promise<StudioState> {
  const token = await getToken();
  const res = await fetch(stateUrl(), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`BFF GET /prototyper/state ${res.status}`);
  return res.json() as Promise<StudioState>;
}

export async function saveState(state: StudioState): Promise<void> {
  const token = await getToken();
  const res = await fetch(stateUrl(), {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(state),
  });
  if (!res.ok) throw new Error(`BFF PUT /prototyper/state ${res.status}`);
}
